import { Slide } from "@jelly/lesson";
import config from "appConfig";

import { task as task02 } from "../../../../../task/course-04/lesson-14/task-02";

const task: Slide = {
  titleHtml:
    "3 pure tones coming from 3 different directions are impinging the membrane of a microphone:<br>the 100 Hz sound is coming on axis, the 300 Hz sound is coming at 90° and the 600 Hz sound is<br>coming at 180°. From the time signal plotted below, could you guess the directivity type<br>(omnidirectional, hypocardioid, cardioid, supercardioid, hypercardioid, bidirectional)?",
  description: "Fill in the value.",
  layout: {
    type: "table",
    options: {
      cols: 1,
      rows: 2,
      rowsSize: [4, 1],
      components: [
        [
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "image",
                options: {
                  src: `${config.ASSETS_URL}/04/14/task/task-2.svg`,
                },
              },
            },
          },
        ],
        [
          {
            variant: "__task__",
            data: {
              id: task02.id,
            },
          },
        ],
      ],
    },
  },
};

export default task;
